import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FiPhoneCall } from 'react-icons/fi';
import './QuotePage.css';

const QuotePage = () => {
  return (
    <section className="contact-section">
      {/* Background Overlay */}
      <div className="section-overlay"></div>

      <Container className="position-relative">
        <Row className="align-items-center gy-5 py-5">
          {/* Left Side Content */}
          <Col lg={6} md={12} className="text-white">
            <div className="brand-content text-start">
              <h1 className="display-5 fw-bold mb-4">
                Let’s Move Your Vehicles <br /> with Confidence
              </h1>
              <p className="lead opacity-75 mb-0" style={{ maxWidth: '500px' }}>
                Get in touch with Janta Roadways for safe, compliant, and reliable
                automobile and heavy cargo transportation across India.
              </p>
            </div>
          </Col>

          {/* Right Side Form Card */}
          <Col lg={6} md={12} className="form-column">
            <div className="enquiry-card">
              <h3 className="enquiry-title mb-4">Transport Enquiry</h3>

              <Form>
                <Row className='row'>
                  <Col md={6} className="mb-3">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter your full name" />
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter your company name" />
                  </Col>
                </Row>

                <Row className='row'>
                  <Col md={6} className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control type="tel" placeholder="Enter your Phone Number" />
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" placeholder="Enter your Email Address" />
                  </Col>
                </Row>

                <Row className='row'>
                  <Col md={6} className="mb-3">
                    <Form.Label>City / Location</Form.Label>
                    <Form.Control type="text" placeholder="Enter your City / Location" />
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Label>Transport Mode / Cargo Type</Form.Label>
                    <Form.Control type="text" placeholder="Cargo Type" />
                  </Col>
                </Row>

                <Form.Group className="mb-4">
                  <Form.Label>Transport Requirement</Form.Label>
                  <Form.Control as="textarea" rows={3} placeholder="Enter your Requirement" />
                </Form.Group>

                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <Button className="btn-quote">
                    GET A QUOTE
                  </Button>
                  <div className="contact-link d-flex align-items-center">
                    <FiPhoneCall className="me-2 text-danger" />
                    <span className="fw-bold">+91 XXXXX XXXXX</span>
                  </div>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default QuotePage;